import React from 'react';
import { motion } from 'framer-motion';
import { FaExclamationTriangle } from 'react-icons/fa';
import '../styles/ErrorMessage.css';

const ErrorMessage = ({ message }) => {
  if (!message) return null;
  
  return (
    <motion.div 
      className="error-message-container"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.3 }}
    >
      <div className="error-content">
        <FaExclamationTriangle className="error-icon" />
        <p>{message}</p>
      </div>
    </motion.div>
  );
};

export default ErrorMessage;
